var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'icons-tile',
    {
        'icons-tile--active': _vm.active,
        'icons-tile--no-hover': _vm.noHover,
    }
]},[_c('router-link',{class:[
            'icons-tile__top',
            {
                'icons-tile__top--no-action' : !_vm.actionTitle.length,
                'icons-tile__top--disabled': _vm.disabled,
            }
        ],attrs:{"title":_vm.slotTitle,"to":_vm.url}},[(!_vm.active && _vm.actionTitle.length)?_c('div',{class:['icons-tile__overlay', { 'icons-tile__overlay--no-hover': _vm.noHover }]}):_vm._e(),_c('div',{staticClass:"icons-tile__icons"},[_c('i',{class:("icon icon-" + _vm.icon)}),_c('i',{class:("status icon-" + (_vm.setStatus(_vm.status)))})]),_c('div',{staticClass:"icons-tile__text"},[_vm._t("default")],2)]),(_vm.actionTitle.length)?_c('div',{staticClass:"icons-tile__bottom",on:{"click":function($event){return _vm.$emit('actionClick');}}},[_vm._v(" "+_vm._s(_vm.actionTitle)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }